import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import OrderProduct from "./orderproduct";
import OrderEditForm from "./OrderEditForm";
import { Link } from 'react-router-dom';


class OrderSummary extends Component {
    constructor(...args) {
        super(...args);
        this.props.location.hasOwnProperty('Order') ?
        this.state = {
            showBanner: false, message: '', activeTab:this.props.location.Order.tab, OrderData : []
        }:this.state = {
            showBanner: false, message: '', activeTab:null, OrderData : []
        }

    }
    toggle = tab => {
        if (this.state.activeTab !== tab)
            this.setState(prevState => ({
                ...prevState, activeTab : tab
            }));

    }
    closeBanner = () => {
        this.setState({
            showBanner: false, message: ''
        });
    };
    
    //Load from axios
    componentDidMount() {
    }


    render() {
        console.log(this.props)
     if (this.state.activeTab == null) {
     return (
        <Redirect to="/order-search"/>
     )
    }
        return (
            <div style={{ marginLeft:"5%", marginRight:"5%" }}>
                <hr style={{marginBottom:"0px",marginTop:"2px"}}/>
                <Nav pills >
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}>
                            Order
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}>
                            Products
                        </NavLink>
                    </NavItem>
                    
                </Nav>
                <hr style={{marginBottom:"7px",marginTop:"0px"}}/>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                        {this.state.activeTab === '1' && <OrderEditForm OrderId={this.props.location.Order.Id}/>}
                    </TabPane>
                    <TabPane tabId="2">
                        {this.state.activeTab === '2' && (<OrderProduct OrderId={this.props.location.Order.Id}/>)}
                    </TabPane>
                </TabContent>
            </div>
        );
    };
}
export default OrderSummary